var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addCode" },
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("add"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                model: _vm.paramsData,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.envIdChange },
                      model: {
                        value: _vm.paramsData.env_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "env_id", $$v)
                        },
                        expression: "paramsData.env_id"
                      }
                    },
                    _vm._l(_vm.szgmEnv, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("serverChannel")
                      },
                      on: { change: _vm.serverChange },
                      model: {
                        value: _vm.server_channel,
                        callback: function($$v) {
                          _vm.server_channel = $$v
                        },
                        expression: "server_channel"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("showTestServer")
                      },
                      on: { change: _vm.serverChannelChange },
                      model: {
                        value: _vm.show_test,
                        callback: function($$v) {
                          _vm.show_test = $$v
                        },
                        expression: "show_test"
                      }
                    },
                    _vm._l(_vm.serverType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { label: "" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        filterable: "",
                        placeholder: _vm.$t("server")
                      },
                      on: { change: _vm.severChange },
                      model: {
                        value: _vm.paramsData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_id", $$v)
                        },
                        expression: "paramsData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                      ),
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "reason", label: _vm.$t("reason") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectReason")
                      },
                      model: {
                        value: _vm.paramsData.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "reason", $$v)
                        },
                        expression: "paramsData.reason"
                      }
                    },
                    _vm._l(_vm.reasonList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "mode", label: _vm.$t("whitelistOption") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelect")
                      },
                      model: {
                        value: _vm.paramsData.mode,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "mode", $$v)
                        },
                        expression: "paramsData.mode"
                      }
                    },
                    _vm._l(_vm.nameList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }